export default __webpack_public_path__ + "static/media/GFGKIITWebsitePoster.0c3aae94.ab5d1d1c.jpg";